import React, { useState } from "react";
import { Col, Row, Select, Space } from "antd";
import styled from "styled-components";
import ICF from "./ICF/ICF";
import CRF from "./CRF/CRF";
import PLPS from "./PLPS/PLPS";
import FloatingChatBot from "./CRF/FloatingChatBot";
import otsukaLogo from "./../../../assets/otsuka.png";
import GroupLogo from "./../../../assets/Group.png";
import { CRFstudy, ICFstudy, PLPSstudy } from "../../../constant";

const { Option } = Select;

export const StyledSelect = styled(Select)`
  width: 90%;
  height: auto;
  font-size: 14px;
  font-weight: 600;
  color: #426bba;
  border-radius: 1rem !important;
  box-shadow: 0 2px 6px rgba(66, 107, 186, 0.2);

  && .ant-select-selector {
    background-color: #e3ecff !important;
    border: none !important;
    border-radius: 1rem !important;
    padding: 4px 16px;
    color: #426bba !important;
  }

  && .ant-select-selection-item,
  && .ant-select-selection-placeholder {
    color: #426bba !important;
  }

  && .ant-select-arrow {
    color: #426bba !important;

    svg {
      fill: #426bba !important;
    }
  }

  && .ant-select-dropdown {
    background-color: #e3ecff;
    color: #426bba;
    border-radius: 1rem;
  }

  && .ant-select-item-option-content {
    color: #426bba;
  }

  &:hover .ant-select-selector {
    background-color: #d7e4ff !important;
    color: #426bba !important;
  }
`;

const FormSelector = () => {
  const [selectedForm, setSelectedForm] = useState(null);

  const handleSelect = (selected) => {
    if (selected === CRFstudy) {
      setSelectedForm(CRFstudy);
    } else if (selected === ICFstudy) {
      setSelectedForm(ICFstudy);
    } else if (selected === PLPSstudy) {
      setSelectedForm(PLPSstudy);
    }
  };

  const goBack = () => {
    setSelectedForm(null);
  };

  return (
    <>
      {selectedForm === null && (
        <>
          <Row justify="center" style={{ padding: "16px" }}>
            <Col xs={24} sm={18} md={12} lg={8}>
              <Space direction="vertical" size="large" style={{ width: "100%", textAlign: "center", marginTop: 100 }}>
                <img src={otsukaLogo} alt="otsukaLogo" style={{ marginRight: 16, width: "45%" }} />
                <StyledSelect placeholder="Select Deliverable" onChange={handleSelect}>
                  <Option value={CRFstudy}>Case Report Form</Option>
                  <Option value={ICFstudy}>Informed Consent Form</Option>
                  <Option value={PLPSstudy}>Plain Language Protocol Synopsis</Option>
                </StyledSelect>
              </Space>
            </Col>
          </Row>
        </>
      )}
      {selectedForm === CRFstudy && <CRF onBack={goBack} />}
      {selectedForm === ICFstudy && <ICF onBack={goBack} />}
      {selectedForm === PLPSstudy && <PLPS onBack={goBack} />}
      <FloatingChatBot />
      <img
        src={GroupLogo}
        alt="Group Logo"
        style={{
          position: "absolute",
          bottom: "0px",
          right: "0px",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
    </>
  );
};

export default FormSelector;
